var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.6 2C3.166 2 2 3.166 2 4.6C2 11.988 8.011 18 15.4 18C16.833 18 18 16.834 18 15.4C18 15.289 17.993 15.18 17.979 15.072L13.359 14.012C13.267 14.188 13.166 14.379 13.074 14.557C12.618 15.427 12.288 16.059 11.446 15.72C8.14 14.56 5.441 11.86 4.266 8.514C3.909 7.729 4.589 7.373 5.451 6.923C5.626 6.831 5.815 6.732 5.988 6.642L4.928 2.021C4.817 2.007 4.709 2 4.6 2ZM15.4 20C6.908 20 0 13.092 0 4.6C0 2.063 2.063 0 4.6 0C4.86 0 5.117 0.022 5.366 0.065C5.609 0.104 5.853 0.166 6.091 0.248C6.416 0.361 6.661 0.634 6.738 0.97L8.107 6.934C8.183 7.262 8.088 7.606 7.854 7.85C7.718 7.992 7.715 7.995 6.475 8.644C7.479 10.818 9.224 12.557 11.354 13.527C12.004 12.286 12.008 12.282 12.15 12.146C12.394 11.912 12.74 11.821 13.066 11.893L19.031 13.262C19.366 13.339 19.639 13.583 19.751 13.908C19.833 14.144 19.895 14.388 19.936 14.639C19.978 14.886 20 15.142 20 15.4C20 17.937 17.936 20 15.4 20Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phoneIcon.2fcb7f355d21ca71c900f0e6362e06d5.svg";
export { ForwardRef as ReactComponent };